























import { JobReference } from '../../interfaces/JobReference'
import { JobTree } from '../../types/JobTree'
import { GroupedJobs, TreeItem } from '../../types/TreeItem'
import { Job } from '@rundeck/client/dist/lib/models'
import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { client } from '../../modules/rundeckClient'



@Component
export default class ProjectPicker extends Vue {
  @Prop({ required: false, default: '' })
  value!: string

  projects: string[] = []

  loadProjects() {
      this.projects.push('')
      client.projectList().then(result => {
          result.forEach(prj => {
              if(prj.name) this.projects.push(prj.name)
          })
      })
  }

  mounted() {
    this.loadProjects()
  }
}
